export const Logo = () => (
  <a
    href="#top"
    data-testid="brand-logo-link"
    className="flex items-center group"
    aria-label="KW Mortgages — back to top"
  >
    <img
      src="/kw-logo.png"
      alt="KW Mortgages logo"
      className="h-11 w-auto rounded-lg bg-white px-2.5 py-1.5 transition-transform duration-300 group-hover:scale-[1.03]"
    />
  </a>
);
